/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2022] Narbase Technologies
 * All Rights Reserved.
 * Created by Shalaga44
 * On: 2022/Jun/20.
 */

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2022] Narbase Technologies
 * All Rights Reserved.
 * Created by Shalaga44
 * On: 2022/Jun/20.
 */

package com.narbase.letsgo.models

import com.narbase.letsgo.dto.EnumDtoName
import kotlin.js.JsExport


@JsExport
enum class Direction(val key: String) {
    LTR("ltr"),
    RTL("rtl"), ;

    fun toHtmlDirection(): String {
        return this.key
    }

}

@JsExport
enum class Language(
    val locale: String,
    val label: String,
    val languageName: String,
    val imageSrc: String,
    val direction: Direction,
    val appFontFamily: String,
    dtoName: String? = null,
) : EnumDtoName {

    En(
        "en-GB",
        "Change to English",
        "English",
        "/public/img/english.png",
        Direction.LTR,
        "'Mulish', 'Noto Sans Arabic', sans-serif"
    ),
    Ar(
        "ar-EG-u-nu-latn",
        "التغير الى العربية",
        "العربية",
        "/public/img/arabic.png",
        Direction.RTL,
        "'Noto Sans Arabic', 'Mulish', sans-serif"
    ),

    Fr(
        "fr",
        "Changer la langue en français",
        "Français",
        "/public/img/arabic.png",
        Direction.LTR,
        "'Mulish', 'Noto Sans Arabic', sans-serif"
    ),

    ;

    override val dtoName = dtoName ?: this.name

    fun toHtmlLanguage(): String {
        return this.locale
    }


}

fun String.toLanguage(): Language {

    return Language.values()
        .firstOrNull { (it.locale.lowercase() == this.lowercase()) || (it.name.lowercase() == this.lowercase()) }
        ?: throw NotImplementedError("Language key: {$this} is not implemented!")


}
